import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgStyle = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path fillOpacity={0.01} fill="#FFF" d="M.644.86h24v24h-24z" />
      <path
        d="M9.311 1.96h-3.03a.9.9 0 0 0-.75.4L1.897 7.815l-.061.106a.9.9 0 0 0 .224 1.076l2.866 2.457.001 11.405a.9.9 0 0 0 .9.9h13.637l.112-.007a.9.9 0 0 0 .788-.893V11.454l2.867-2.457a.9.9 0 0 0 .163-1.182L19.757 2.36a.9.9 0 0 0-.749-.4h-3.03a.9.9 0 0 0-.9.9 2.433 2.433 0 1 1-4.867 0 .9.9 0 0 0-.9-.9Zm9.214 1.8 2.928 4.39-2.576 2.208-.08.078a.9.9 0 0 0-.234.605V21.96H6.724l.001-10.918-.007-.111a.9.9 0 0 0-.307-.572L3.834 8.149l2.928-4.39h1.745l.03.128a4.235 4.235 0 0 0 4.107 3.206l.212-.005a4.236 4.236 0 0 0 3.896-3.201l.028-.128h1.745Z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgStyle)
const Memo = memo(ForwardRef)
export default Memo
